import { Icon } from 'prensa'
import React from 'react'

const IconTelegram = (props) => {
  return (
    <Icon xmlns='http://www.w3.org/2000/svg' {...props}>
      <path fillRule='evenodd' clipRule='evenodd' d='M24.362 12.5c0 6.627-5.373 12-12 12-6.628 0-12-5.373-12-12s5.372-12 12-12c6.627 0 12 5.373 12 12Zm-11.57-3.141c-1.167.485-3.5 1.49-6.998 3.014-.568.226-.866.447-.893.663-.046.366.412.51 1.034.705.085.027.173.054.263.084.612.199 1.437.432 1.865.441.389.008.823-.152 1.301-.48 3.269-2.207 4.956-3.322 5.062-3.346.075-.017.178-.038.249.024.07.062.063.18.055.212-.045.193-1.84 1.862-2.77 2.726-.289.269-.494.46-.536.504-.094.097-.19.19-.282.279-.57.548-.996.96.023 1.632.49.323.883.59 1.274.856.427.291.853.581 1.404.943.14.092.275.187.406.28.497.355.944.673 1.495.623.321-.03.652-.331.82-1.23.398-2.126 1.18-6.73 1.36-8.628a2.123 2.123 0 0 0-.02-.472.506.506 0 0 0-.17-.325c-.145-.117-.367-.142-.466-.14-.451.008-1.144.249-4.476 1.635Z'/>
    </Icon>
  )
}

export default IconTelegram

